import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsForm from "./en-us/form.json";
import localizationEnUsItems from "./en-us/items.json";

export const localizationEnUsInvoiceView = {
  ...localizationEnUsHeader,
  ...localizationEnUsForm,
  ...localizationEnUsItems,
};
